import React from "react";
import { AuthState, AuthUser, AuthStorage } from "./AuthStorage";

type AuthContextValue = {
  state: AuthState;
  setUser: (user: AuthUser) => void;
  logout: () => void;

  // individual helpers
  user: AuthUser | null;
  userName: string | null;
  userEmail: string | null;
  userMobile: string | null;
  isLogin: boolean;
};

const AuthContext = React.createContext<AuthContextValue | null>(null);

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [state, setState] = React.useState<AuthState>(() =>
    AuthStorage.getState(),
  );

  const setUser = (user: AuthUser) => {
    AuthStorage.setUser(user);
    setState(AuthStorage.getState());
  };

  const logout = () => {
    AuthStorage.clear();
    setState(AuthStorage.getState());
  };

  const value: AuthContextValue = {
    state,
    setUser,
    logout,

    user: state.user,
    userName: state.user?.userName ?? null,
    userEmail: state.user?.userEmail ?? null,
    userMobile: state.user?.userMobile ?? null,
    isLogin: state.isLogin,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export function useAuth() {
  const ctx = React.useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used inside <AuthProvider>");
  return ctx;
}
